import React, { useState } from "react";
import { ReactComponent as HospitalIcon } from "../../assets/images/hospital-orange.svg";
import "./HospitalListing.scss";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import ActionModal from "../../pages/comparison/ActionModal";
import { getHospitalCountData } from "../../redux/slices/comparison.Slice";
import { Col, Row } from "react-bootstrap";

const HospitalListing = ({ restrictedData }) => {
  const [subAlertModal, setSubAlertModal] = useState(false);
  const [subText, setSubText] = useState({
    header: "",
    desc: "",
    isCityAdd: false,
  });
  const [isRestrictedData, setIsRestrictedData] = useState(restrictedData);
  const [messageType, setMessageType] = useState("");
  const navigate = useNavigate();
  const location = useLocation();
  const dispatch = useDispatch();
  const store = useSelector((state) => state.comparison);

  let hospitalList = [];

  if (location.pathname === "/full-map") {
    hospitalList = store?.hospitalItems?.data?.hospitals || [];
  } else {
    hospitalList = store?.hospitalItems?.data?.hospitals
      ? store?.hospitalItems?.data?.hospitals
      : [];
  }

  const showSubModal = (type) => {
    setMessageType(type);

    let header = "Subscription Required!";
    let desc = "";

    if (type === "limit") {
      desc = isRestrictedData?.comparisanMessage;
    } else {
      // if (planExpired) {
      //   desc =
      //     "Your plan has expired. Subscribe now to unlock all the benefits.";
      // } else {
      const subscriptionType = "" ? "Pro" : "Plus/Pro";
      desc = `This feature is available with our ${subscriptionType} subscription. Would you like to subscribe now and unlock all the benefits?`;
      // }
    }

    // setSubText({
    //   header,
    //   desc,
    //   isCityAdd: false,
    // });

    setTimeout(() => {
      setSubAlertModal(true);
    }, 500);
  };

  // const handleHospitalClick = (hospital) => {
  //   navigate(`/search/details/${hospital?.city_id}`, {
  //     state: { from: "hospital", hospitalData: hospital, hospitalList },
  //   });
  // };

  const handleHospitalClick = async (hospital) => {
    try {
      const obj = { hospital_id: hospital?.id, is_count: true };
      const result = await dispatch(getHospitalCountData(obj)).unwrap();
      console.log(result, "Data Of Result");
      const data = result?.hospitalCountItems;
      if (!data) {
        // showSubModal("limit");
        setSubAlertModal(true);
        return;
      }
      console.log(data, "data.success === true");

      setIsRestrictedData({
        is_comparisan: data?.is_comparisan,
        comparisanMessage: data?.comparisanMessage,
        header: data?.header,
        messageBody1: data?.messageBody1,
        messageBody2: data?.messageBody2,
        comparisanMaxCount: data?.comparisanMaxCount,
        remaining_count: data?.remaining_count,
      });

      if (data?.incrementSuccess === true) {
        navigate(`/search/details/${hospital?.city_id}`, {
          state: { from: "hospital", hospitalData: hospital, hospitalList },
        });
      } else {
        setSubAlertModal(true);
      }
    } catch (error) {
      console.error("Error fetching hospital count:", error);
      // showSubModal("limit");
      setSubAlertModal(true);
    }
  };

  return (
    // <div className="hospitals-container">
    //   {hospitalList?.map((hospital, index) => (
    //     <div
    //       key={index}
    //       className="hospital-item cursor-pointer"
    //       onClick={() => handleHospitalClick(hospital)}
    //     >
    //       <div className="content-wrap">
    //         <div className="hospital-icon">
    //           <HospitalIcon />
    //         </div>
    //         <div className="hospital-details">
    //           <div className="hospital-name">{hospital?.hospital_name}</div>
    //           <div className="hospital-address">{hospital?.full_address}</div>
    //         </div>
    //       </div>
    //     </div>
    //   ))}
    //   <ActionModal
    //     title={isRestrictedData.header}
    //     description={isRestrictedData.comparisanMessage}
    //     isVisible={subAlertModal}
    //     onClose={() => {
    //       // handleScroll?.(true);
    //       setMessageType("role");
    //       setSubAlertModal(false);
    //     }}
    //     onPressYes={async () => {
    //       // handleScroll?.(true);
    //       setMessageType("role");
    //       navigate("Subscription");
    //       setSubAlertModal(false);
    //     }}
    //     yesText="Upgrade Now"
    //     noText="Cancel"
    //     extraMetaInfo={messageType === "limit"}
    //     extraData={isRestrictedData}
    //     // userData={userPlanData}
    //   />
    // </div>
     <Row className="hospitals-container">
      {hospitalList?.map((hospital, index) => (
        <Col md={6} xs={12} key={index}>
          <div
            className="hospital-item cursor-pointer"
            onClick={() => handleHospitalClick(hospital)}
          >
            <div className="content-wrap">
              <div className="hospital-icon">
                <HospitalIcon />
              </div>
              <div className="hospital-details">
                <div className="hospital-name">{hospital?.hospital_name}</div>
                <div className="hospital-address">{hospital?.full_address}</div>
              </div>
            </div>
          </div>
        </Col>
      ))}
      <ActionModal
        title={isRestrictedData.header}
        description={isRestrictedData.comparisanMessage}
        isVisible={subAlertModal}
        onClose={() => {
          // handleScroll?.(true);
          setMessageType("role");
          setSubAlertModal(false);
        }}
        onPressYes={async () => {
          // handleScroll?.(true);
          setMessageType("role");
          navigate("Subscription");
          setSubAlertModal(false);
        }}
        yesText="Upgrade Now"
        noText="Cancel"
        extraMetaInfo={messageType === "limit"}
        extraData={isRestrictedData}
        // userData={userPlanData}
      />
    </Row>
  );
};

export default HospitalListing;
